export type StatusValueOptionType = 'published' | 'draft';
type StatusOptionType = { label: string; value: StatusValueOptionType }[];

const StoryStatusOptions: StatusOptionType = [
  { label: 'Published', value: 'published' },
  { label: 'Draft', value: 'draft' },
];

export default StoryStatusOptions;
